<template>
  <label class="app-radio">
    <input
      :data-value="dataValue"
      :checked="value == dataValue"
      :name="name"
      type="radio"
      @change="update"
      v-bind="$attrs" />
    <span></span>
    {{ label }}
  </label>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'name',
    'dataValue'
  ],
  methods: {
    update(e) {
      this.$emit('input', e.target.getAttribute('data-value'))
    }
  }
}
</script>
